import {
  ManagerCouponCancelRequest,
  ManagerCouponPrintRequest,
  ManagerCouponSendRequest,
} from './managerCoupon.types';
import axios from 'axios';

const api = axios.create({
  baseURL: 'http://localhost:8999/ManagerAPIWeb/nfce',
  auth: {
    username: 'admin',
    password: '123mudar',
  },
  withCredentials: true,
});

export default {
  async send(params: ManagerCouponSendRequest) {
    function transformRequest(data = {}) {
      return Object.entries(data)
        .map(
          ([key, value]) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(value as string)}`,
        )
        .join('&');
    }

    const result = await api.post<string>(
      `/envia`,
      {
        arquivo: params.tx2,
      },
      {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        transformRequest,
      },
    );

    return result.data;
  },

  async cancel(params: ManagerCouponCancelRequest) {
    const result = await api.post<string>(
      `/cancela`,
      {
        ChaveNota: params.sefazReferenceCode,
      },
      { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
    );
    return result;
  },

  async print(params: ManagerCouponPrintRequest) {
    const result = await api.get<string>(`/imprime`, {
      params: { ChaveNota: params.sefazReferenceCode, Url: 0 },
    });
    return result;
  },
};
